function parseISOString(s) {
  if(s) {
    var b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  } else {
    return null;
  }
}

export function fmtIso8601AsLocalDateQualifiedTime(iso8601String, qualifyDateIso8601String = null) {
  let parts=[];
  if(iso8601String) {
    const dttm=parseISOString(iso8601String);
    const tmStr=dttm.toLocaleTimeString();
    let dtStr=dttm.toLocaleDateString();
    if(qualifyDateIso8601String) {
      const qDttm=parseISOString(qualifyDateIso8601String);
      const qDtStr=qDttm.toLocaleDateString();
      if (dtStr!==qDtStr) {
        if(dttm.getFullYear()===qDttm.getFullYear()) {
          parts.push(dtStr.slice(0, -5));
        } else {
          parts.push(dtStr);
        }
      }
    } else {
      parts.push(dtStr);
    }
    parts.push(tmStr);
  }
  return parts.join(" ");
}

export function fmtIso8601AsLocalDate(iso8601String) {
  if(iso8601String) {
    const dttm=parseISOString(iso8601String);
    return dttm.toLocaleDateString();
  } else {
    return "";
  }
}

export function fmtIso8601AsLocalDateTime(iso8601String) {
  if(iso8601String) {
    const dttm=parseISOString(iso8601String);
    return dttm.toLocaleDateString()+" "+dttm.toLocaleTimeString();
  } else {
    return "";
  }
}

export function fmtIso8601AsLocalDateHrsMin(iso8601String) {
  if(iso8601String) {
    const dttm=parseISOString(iso8601String);
    return dttm.toLocaleDateString('en-US', { year: '2-digit', month: 'numeric', day: 'numeric' })+" "+dttm.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit'});
  } else {
    return "";
  }
}
